import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useSelector, useDispatch } from 'react-redux';
import { forumDetailAction, forumTagsAction } from '../../../redux/actions/VdrAction';
import { styled, lighten, darken } from '@mui/system';
import { FORUM_DETAIL_REQUEST } from '../../../constants/VdrConstants';
import { crtUserId } from '../../../constants/helpers';

export default function TagSearchInput({
    ActiveVideoNews,
    ActiveTag,
    setActiveTag,
}) {
    const GroupItems = styled('ul')({
        padding: 0,
      });
    const [TagsDataArr, setTagsDataArr] = React.useState();

    const {
        loading:ForumLoading,
    } = useSelector(state => state.ForumReducer)

    const {
        data: TagData,
        loading: TagLoading
    } = useSelector(state=>state.ForumTagsReducer);

    const dispatch = useDispatch();

    let userId = crtUserId()

    React.useEffect(()=>{
        if(TagLoading){
            dispatch(forumTagsAction())
        }
        if(!TagLoading){
            // console.log('TagData >>>> ', TagData);
            let a0 = [] 
            TagData.data.map(item => {
                let a0Obj = { title: item.name, year: item.tag_id, value: item.tag_id }
                a0.push(a0Obj);
            })
            const unique = a0.filter((obj, index) => {
                return index === a0.findIndex(o => obj.title === o.title);
            });

            setTagsDataArr(unique)
            
        }
    }, [dispatch, TagLoading])


  return (
    <>
        {/* <Autocomplete
            id="grouped-demo"
            options={TagsDataArr}
            getOptionLabel={(option) => option.label}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Tags Search..." />}
            renderGroup={(params) => (
                <li key={params.id}>
                    <GroupItems>{params.children}</GroupItems>
                </li>
            )}
        /> */}

            <Autocomplete
                sx={{ width: 300 }}
                id="asynchronous-demo"
                className='asynchronous-demo'
                // {...props}
                // style={cst_style}
                // fullWidth
                // open={open}
                // onKeyPress={() => {
                //     setOpen(true);
                // }}
                // onPaste={() => {
                //     setOpen(true);
                // }}
                // onClose={() => {
                //     setOpen(false);
                // }}
                onChange={(event, newInputValue) => {
                    var val1 = newInputValue;
                    setActiveTag(val1);

                    console.log(val1);

                    // if(!ForumLoading && ActiveVideoNews && ActiveVideoNews.company_slug){
                        // console.log('data?.BlogAddonTot_date ???? ', data)
                        // dispatch({ type: FORUM_DETAIL_REQUEST });
                        // let params = {
                        //     "slug": ActiveVideoNews.company_slug,
                        //     "user_id": userId,
                        //     "tag_id": val1?.value,
                        // }
                        // dispatch(forumDetailAction(params));
                        // setActiveVideo("")
                        
                    //   }

                        // val1['CompanyID']= val1.value;
                        // if((window.location.href).includes('vdr') || (window.location.href).includes('localhost') || !(window.location.href).includes('/company-detail')){
                        // navigation(`/company-detail/${window.btoa(val1?.value)}`)
                        // }else{
                        // navigation(`/company-detail/${window.btoa(val1?.value)}`)
                        // // navigation(`/${window.btoa(val1?.value)}`)
                        // }
                        // window.location.href = window.location.href;

                    }}

                isOptionEqualToValue={(option, value) => option.title === value.title}
                getOptionLabel={(option) => option.title}
                options={TagsDataArr}
                // loading={loading}
                size='small'
                freeSolo
                renderInput={(params) => (
                    <TextField
                    {...params}
                    placeholder='Search Company...'
                    variant='outlined'
                    onKeyDown= {(e) => {
                                    if (e.key === 'Enter') {
                                    e.stopPropagation();
                                    }
                                }}
                    // InputProps={{
                    //     ...params.InputProps,
                    //     endAdornment: (
                    //     <>
                    //         {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    //         {params.InputProps.endAdornment}
                    //     </>
                    //     ),
                    // }}
                    />
                )}
                />

    </>
  );
}
